import TRANSACTIONAL_PROFILE_LABELS from '../translations/transactionalProfile.translations';

const createReverseTranslationMap = () => {
  const reverseMap: Record<string, string> = {};

  Object.entries(TRANSACTIONAL_PROFILE_LABELS.EN).forEach(
    ([key, translation]) => {
      if (key.startsWith('tpProducts') && key !== 'tpProducts') {
        reverseMap[translation] = key;
      }
    }
  );

  Object.entries(TRANSACTIONAL_PROFILE_LABELS.ES).forEach(
    ([key, translation]) => {
      if (key.startsWith('tpProducts') && key !== 'tpProducts') {
        reverseMap[translation] = key;
      }
    }
  );

  return reverseMap;
};

const getOriginalKeysFromTranslations = (
  translatedValues: string[]
): string[] => {
  const reverseMap = createReverseTranslationMap();

  return translatedValues
    .map((value) => value.trim())
    .map((value) => reverseMap[value])
    .filter(Boolean);
};

export default getOriginalKeysFromTranslations;
